<div
  class="w-full bg-base-300 p-5 md:px-0 max-w-3xl mx-auto flex justify-between items-center mb-2 md:mb-10"
>
  <button
    class="btn p-0 bg-transparent hover:bg-transparent h-fit border-0 w-32 shadow-none dark:hidden"
  >
    <img class="w-full" src="/assets/logo/qwikopay-hz-logo-dark.svg" alt="" />
  </button>
  <button
    class="btn p-0 bg-transparent hover:bg-transparent h-fit border-0 w-32 shadow-none hidden dark:!flex"
  >
    <img class="w-full" src="/assets/logo/qwikopay-hz-logo-light.svg" alt="" />
  </button>

  <button
    *transloco="let t"
    (click)="signOut()"
    class="btn btn-sm btn-primary border btn-outline dark:!text-base-content dark:!border-base-100 dark:!btn-ghost"
    [disabled]="loading()"
  >
    @if (loading()) {
      <span class="loading loading-spinner"></span>
    } @else {
      <span> {{ t("logout") }} </span>
    }
  </button>
</div>
